const intlCache: Record<string, Intl.NumberFormat> = {};

/** Shown in place of a price that cannot be formatted. */
export const EMPTY_PRICE = '-\xA0Ft';

type PriceObject = {
  locale: string,
  currency: string,
  priceValue: number,
};

export function formatPriceToStr (arg: PriceObject) {
  const priceObj: unknown = arg;
  if (!isValidPriceObject(priceObj)) {
    return EMPTY_PRICE;
  }
  const { locale, currency, priceValue } = priceObj;
  if (!intlCache[locale]) {
    intlCache[locale] = new Intl.NumberFormat(
      locale,
      {
        style: 'currency',
        currency,
        ...forceHufFormat(currency),
      },
    );
  }
  try {
    return intlCache[locale].format(priceValue);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return `${priceValue}\xA0${currency}`;
  }
}
function isValidPriceObject (arg: unknown): arg is PriceObject {
  if (!arg || typeof arg !== 'object') {
    return false;
  }
  const { locale, currency, priceValue } = (arg as Record<string, unknown>);
  if (
    typeof locale !== 'string' ||
    typeof currency !== 'string' ||
    typeof priceValue !== 'number'
  ) {
    return false;
  }
  return true;
}
function forceHufFormat (currency: string) {
  return ((currency === 'HUF')
    ? {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }
    : null
  );
}
